import { render } from "./Level.vue?vue&type=template&id=09067a0d&scoped=true"
import script from "./Level.vue?vue&type=script&lang=js"
export * from "./Level.vue?vue&type=script&lang=js"

import "./Level.vue?vue&type=style&index=0&id=09067a0d&lang=scss&scoped=true"
import "./Level.vue?vue&type=style&index=1&id=09067a0d&lang=scss"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09067a0d"]])

export default __exports__